import { CrmDefaults } from '@jewelutions/core-crm-domain';

export class GQLPartyHelper {
  static isSystemParty(partyId: string) {
    return [CrmDefaults.platformPartyId, CrmDefaults.platformPrototypeMerchantPartyId].includes(partyId);
  }
}
